export const prospectSellabilityLabels: { [key: string]: string } = {
  1: 'Per niente vendibile',
  2: 'Poco vendibile',
  3: 'Vendibile',
  4: 'Abbastanza vendibile',
  5: 'Molto vendibile',
};
